import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CommunicationHistoryItem = ({ communication, onViewDetails }) => {
  const getTypeIcon = (type) => {
    const icons = {
      email: 'Mail',
      sms: 'MessageSquare',
      call: 'Phone',
      complaint: 'AlertCircle',
      feedback: 'MessageCircle'
    };
    return icons?.[type] || 'MessageSquare';
  };

  const getTypeColor = (type) => {
    const colors = {
      email: 'text-primary',
      sms: 'text-success',
      call: 'text-warning',
      complaint: 'text-error',
      feedback: 'text-accent'
    };
    return colors?.[type] || 'text-muted-foreground';
  };

  const getStatusBadge = (status) => {
    const badges = {
      pending: { label: 'En attente', color: 'bg-warning/10 text-warning' },
      resolved: { label: 'Résolu', color: 'bg-success/10 text-success' },
      in_progress: { label: 'En cours', color: 'bg-primary/10 text-primary' },
      closed: { label: 'Fermé', color: 'bg-muted text-muted-foreground' }
    };
    return badges?.[status] || badges?.pending;
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('fr-FR', { 
      day: '2-digit', 
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const statusBadge = getStatusBadge(communication?.status);

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg bg-muted flex items-center justify-center flex-shrink-0 ${getTypeColor(communication?.type)}`}>
          <Icon name={getTypeIcon(communication?.type)} size={20} />
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h4 className="text-sm font-semibold text-foreground">
              {communication?.subject}
            </h4>
            <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium flex-shrink-0 ${statusBadge?.color}`}>
              {statusBadge?.label}
            </span>
          </div>
          
          <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
            {communication?.message}
          </p>
          
          <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground mb-3">
            <span className="flex items-center gap-1">
              <Icon name="Calendar" size={12} />
              {formatDate(communication?.date)}
            </span>
            {communication?.agent && (
              <>
                <span>•</span>
                <span className="flex items-center gap-1">
                  <Icon name="User" size={12} />
                  {communication?.agent}
                </span>
              </>
            )}
            {communication?.reference && (
              <>
                <span>•</span>
                <span>Réf: {communication?.reference}</span>
              </>
            )}
          </div>
          
          <Button
            variant="ghost"
            size="xs"
            iconName="ExternalLink"
            iconPosition="left"
            onClick={() => onViewDetails(communication?.id)}
          >
            Voir détails
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CommunicationHistoryItem;